import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer275 {
  SUBSCRIPTIONS_OFFER2_75 = PageId.SUBSCRIPTIONS_OFFER2_75,
  CHAT_UPSELL_OFFER2_75 = PageId.CHAT_UPSELL_OFFER2_75,
  UPSELL_OFFER2_75 = PageId.UPSELL_OFFER2_75,
  DOWNLOAD_OFFER2_75 = PageId.DOWNLOAD_OFFER2_75,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
